export default "__VITE_ASSET__kAG7a_P2__"